import { TApplicationState } from '../../types/redux';
import { IPlaceholderImage } from '../../types/aerialView';
import { PLACEHOLDERS } from '../../constants/aerialView';

export function getAerialViewPlaceholders(state: TApplicationState): IPlaceholderImage[] {
  const { aerialView } = state;

  return aerialView.placeholders || PLACEHOLDERS;
}
